import './App.css';
import { Routes, Route, useLocation, useNavigate } from "react-router-dom";
import {Tabs, Tab, Box} from '@mui/material';
import { ClassroomProvider } from './context/ClassroomContext';
import { useAuthContext } from './context/AuthContext';

//npm install react-router-dom (used to route between pages)

// Pages
import Home from './Home';
import Credits from './Credits';
import CourseEditor from './CourseEditor';


// // Components
//import Button from './components/Button';

// https://mui.com/material-ui/all-components/ use this for making ui components
// npm install @mui/material @emotion/react @emotion/styled

function App() {
    // const navigate = useNavigate();
    const location = useLocation();
    const navigate = useNavigate();
    const { accessToken } = useAuthContext();

    return (
        <ClassroomProvider accessToken={accessToken}>
            <div>
                {/* Page Directory Bar */}
                <Box sx={{ bgcolor: 'background.paper', width: '100%', position: 'fixed' }}>
                    <Tabs
                        value={location.pathname}
                        onChange={(_, newValue) => navigate(newValue)}
                        textColor="secondary"
                        indicatorColor="secondary"
                        centered
                    >
                        <Tab value="/" label="Home" />
                        <Tab value="/courses" label="Course Editor" />
                        <Tab value="/credits" label="Credits" />
                    </Tabs>
                </Box>

                {/* Handles URL Page Routing */}
                <div className="routes">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/courses" element={<CourseEditor />} />
                        <Route path="/credits" element={<Credits />} />
                    </Routes>
                </div>
            </div>
        </ClassroomProvider>
        // <div>
        //     {/* Page Directory Bar */}
        //     <Box sx={{ bgcolor: 'background.paper', width: '100%' , position: 'fixed'}}>
        //         <Tabs
        //             value={location.pathname}
        //
        //             onChange={(_, newValue) => navigate(newValue)}
        //             textColor="secondary"
        //             indicatorColor="secondary"
        //             // variant="fullWidth"
        //             centered
        //         >
        //             <Tab value="/" label="Home" />
        //             <Tab value="/credits" label="Credits" />
        //             <Tab value="/courses" label="Course Editor" />
        //             {/* change name later? idk */}
        //         </Tabs>
        //     </Box>
        //
        //     {/* Handles URL Page Routing */}
        //     <div className = "routes">
        //         <Routes>
        //             <Route path="/" element={<Home />} />
        //             <Route path="/credits" element={<Credits />} />
        //             <Route path="/courses" element={<CourseEditor />} />
        //         </Routes>
        //     </div>
        //
        // </div>
    );
}

//{} means that you are putting javascript in
export default App;